// BrandCard.tsx
"use client";
import { SectionItem } from "@/app/lib/features/home/home.types";
import Link from "next/link";
import { FC } from "react";
import FallbackImage from "@/app/components/elements/FallbackImage";
import { trackBrandClick } from "@/app/lib/tracking/interactions";

interface BrandCardProps {
  brand: SectionItem;
}

const BrandCard: FC<BrandCardProps> = ({ brand }) => {
  const brandName = brand.name || brand.title || "Marka";
  const brandSlug = brand.slug || "#";

  return (
    <Link
      href={brandSlug}
      className="group block w-full"
      onClick={() => trackBrandClick(brand.id)}
    >
      <div
        className="w-full rounded-2xl overflow-hidden border-2 border-gray-200 bg-white"
        style={{ position: "relative", aspectRatio: "3 / 4" }}
      >
        <div
          className="w-full h-full flex items-center justify-center p-4"
          style={{ position: "relative" }}
        >
          <FallbackImage
            src={brand.image}
            alt={brandName}
            fill
            className="object-cover group-hover:scale-[1.02] transition-transform duration-200 ease-out"
            fallbackClassName="object-contain opacity-60"
            sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw"
            quality={70}
            loading="lazy"
          />
        </div>
      </div>
    </Link>
  );
};

export default BrandCard;
